import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { CopyBlock } from "react-code-blocks";
import { useParams } from "react-router-dom";
import axios from "axios";
import qs from "qs";

// Custom Components
import Wrapper from "../Components/Wrapper";
import Herosection from "../Components/Herosection";

// Data
import programNames from "../assets/API/programsName";
import Spinner from "../Components/Spinner";

function ProgramDesc() {
  const [spinner, setSpinner] = useState(false);
  const [output, setOutput] = useState(null);
  const { slug } = useParams();

  // Find the selected program based on the URL slug
  const selectedProgram = programNames.find((program) =>
    program.data.find((item) => item.slug === slug)
  );

  const selectedData = selectedProgram?.data.find((item) => item.slug === slug);

  // Function to fetch code output from the API
  async function codeOutput(data) {
    const requestData = qs.stringify({
      code: data.code,
      language: data.language,
      input: data.input || "",
    });

    const config = {
      method: "post",
      url: "https://api.codex.jaagrav.in",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: requestData,
    };

    try {
      setSpinner(true);
      const response = await axios(config);
      setOutput(response.data.output || JSON.stringify(response.data));
      setSpinner(false);
    } catch (error) {
      console.error("Error fetching code output:", error);
    }
  }

  const handleRunClick = () => {
    if (selectedData) {
      codeOutput(selectedData);
    }
  };

  return (
    <Wrapper id="programDescWrapper">
      <Herosection title={selectedData?.name || "Program Details"} />
      <Container>
        <div className="programDescSection my-md-5 my-5">
          <Row className="gap-5">
            <Col lg={6} data-aos="fade-right">
              <div className="code">
                <h4>Code:</h4>
                <div className="allCode">
                  <div className="run_button_wrapper text-end">
                    <button
                      className="codeRunner_button"
                      onClick={handleRunClick}
                    >
                      Run
                    </button>
                  </div>
                  <CopyBlock
                    text={selectedData?.code || "No content available"}
                    language={selectedData?.language || "text"}
                    wrapLongLines={true}
                    wrapLines
                  />
                </div>
              </div>
            </Col>

            <Col lg={5} data-aos="fade-left">
              <div className="output">
                <div className="heading">
                  <h4>Output:</h4>
                  <button
                    className="codeRunner_button"
                    onClick={handleRunClick}
                  >
                    Run
                  </button>
                </div>
                <div className="output-img">
                  {spinner ? (
                    <Spinner />
                  ) : (
                    <CopyBlock
                      text={output || "Run the Code"}
                      language={"text"}
                      wrapLongLines={true}
                      wrapLines
                    />
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </Wrapper>
  );
}

export default ProgramDesc;
